import * as Yup from 'yup';
import { parse as parseDomain } from 'tldts';
import isEmail from 'validator/lib/isEmail';

const emailValidation = Yup.string()
  .trim()
  .required('Please enter your email\u00A0address.')
  .max(80, 'Please use 80 characters or\u00A0less.')
  .test('is-email', 'Please enter a valid email\u00A0address.', (value) => {
    if (!value || !isEmail(value)) return false;
    const domain = value.split('@').pop()!;
    const { isIcann } = parseDomain(domain);
    return isIcann === true;
  });

const emailInfoSchema = Yup.object({
  email: emailValidation
});

export { emailInfoSchema };
